import { Link } from 'react-router-dom';
import styles from './Collections.module.css';

import { Issue } from '../../../../../constants';
import { Loading } from '../../../../../components/loading/Loading';

import { useSection } from '../Sections.hooks';

const SECTION_ID = 15;

export function Collections() {
	const { isLoading, issues, error } = useSection(SECTION_ID);
	if (isLoading) {
		return (
			<div style={{ height: '100%' }}>
				<Loading />
			</div>
		);
	}
	if (error) {
		return <div>{error.message}</div>;
	}

	return (
		<div className={styles['view']}>
			<div className={styles['title']}>
				<h1>Featured Collections</h1>
			</div>
			<div className={styles['issues']}>
				{issues.map((issue) => (
					<IssueComponent key={issue.id} {...issue} />
				))}
			</div>
		</div>
	);
}

function IssueComponent(issue: Issue) {
	const { id, name, cover, description, slug } = issue;
	const url = `/collections/${slug ? slug : id}`;
	const from = `${window.location.pathname}?section=collections`;
	return (
		<Link state={{ from }} to={url} className={styles['issue']}>
			<div className={styles['logo']}>
				<img src={cover} alt={`${name} - Cover`} width={120} />
			</div>
			<h3>{name}</h3>
			<div className={styles['description']}>{description}</div>
		</Link>
	);
}
